import { defineMessages } from 'react-intl';

export default defineMessages({
  notRegisteredUser: {
    id: 'connection.notRegisteredUser',
    defaultMessage:
      'User not registered, you need to contact administrator to create an account and assign you a role {link}.',
  },
  reversIoLink: {
    id: 'connection.reversIoLink',
    defaultMessage: 'Revers.io',
  },
  logout: {
    id: 'view.header.logout',
    defaultMessage: 'Log out',
  },
});
